const ohtLine = new URL('../../icons/oht-line.png', import.meta.url).href

export default {
  type: 'OHT Line',
  description: 'OHT Line',
  icon: ohtLine,
  group: 'OCS',
  model: {
    type: 'OHTLine',
    left: 200,
    top: 100,
    width: 100,
    height: 20
  }
}
